/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Card, Accordion } from 'react-bootstrap';
import { changeIcon, CustomToggle } from './events';
import { getBorderStyle } from '../../../middleware/getStyle';
import { migrateSpecialCharacters } from '../../formComponent/utils';

const AccordionComponent = (props: any) => {
  const { parameters, customisations } = props;
  const accordionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // All panels start collapsed, so pause any autoplay audio nested in them
    // until the panel that contains it is actually opened.
    accordionRef.current?.querySelectorAll<HTMLAudioElement>('audio[autoplay]').forEach((audio) => {
      audio.pause();
    });
  }, []);
  const fontHeadings = customisations.fontHeadings !== '' ? customisations.fontHeadings : 'div';
  const borderStyle = getBorderStyle(customisations);
  const headerStyle = {
    fontFamily: `${customisations.fontFamily}`,
    fontStyle: `${customisations.fontStyle}`,
    backgroundColor: `${customisations.bgcolor}`,
    fontWeight: `${customisations.fontWeight}`,
    fontSize: `${customisations.fontSize}px`,
    color: `${customisations.fontColor}`,
    textAlign: `${customisations.alignment}` as any,
  };
  const marginStyle = {
    marginTop: customisations.marginTop ? `${customisations.marginTop}px` : '0',
    marginBottom: customisations.marginBottom ? `${customisations.marginBottom}px` : '0',
  };

  const handleClick = (event: any) => {
    const { icon } = props.customisations;
    changeIcon(event.target, icon);
    setTimeout(() => {
      event.target.scrollIntoView({
        behavior: 'auto',
        block: props.isLMSView ? 'nearest' : 'end',
        inline: 'nearest',
      });
    }, 500);
  };

  const playPanelAudio = (node: HTMLElement) => {
    node.querySelectorAll<HTMLAudioElement>('audio[autoplay]').forEach((audio) => {
      audio.play().catch(() => {});
    });
  };

  const pausePanelAudio = (node: HTMLElement) => {
    node.querySelectorAll<HTMLAudioElement>('audio').forEach((audio) => audio.pause());
  };

  return (
    <Accordion
      ref={accordionRef}
      id='customAccordion'
      className={customisations.radius === 'rounded-lg' ? 'rounded-3' : customisations.radius}
      tabIndex={0}
      aria-label='Accordion'
    >
      {parameters?.map((content: { title: string; text: string }, idx: string) => (
        <Accordion.Item eventKey={idx} key={content['title']} style={marginStyle}>
          <Card style={headerStyle}>
            <Card.Body
              as={CustomToggle}
              headerStyle={fontHeadings}
              style={headerStyle}
              className={`${
                customisations.icon === 'plus/minus' ? 'icon-plus' : 'icon-right-arrow'
              }`}
              borderRadius={customisations.radius}
              onKeyDown={(e) => handleClick(e)}
              onClick={(e) => handleClick(e)}
              id={idx}
              eventKey={idx}
            >
              {migrateSpecialCharacters(content['title'])}
            </Card.Body>
          </Card>
          <Accordion.Body
            className='ql-editor'
            style={borderStyle}
            tabIndex={0}
            onEntered={(node: HTMLElement) => playPanelAudio(node)}
            onExit={(node: HTMLElement) => pausePanelAudio(node)}
          >
            {ReactHtmlParser(content['text'])}
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};

export default AccordionComponent;
